export default __webpack_public_path__ + "static/media/intimation-of-postal-ballot-notice-19.10.2026.8d08aa4c.pdf";